var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44734 13.8555C2.35029 12.9526 3.57496 12.4453 4.85192 12.4453H13.1482C14.4252 12.4453 15.6499 12.9526 16.5528 13.8555C17.4558 14.7585 17.963 15.9832 17.963 17.2601V19.3342C17.963 19.7024 17.6646 20.0009 17.2964 20.0009C16.9282 20.0009 16.6297 19.7024 16.6297 19.3342V17.2601C16.6297 16.3368 16.2629 15.4513 15.61 14.7983C14.9571 14.1454 14.0716 13.7786 13.1482 13.7786H4.85192C3.92858 13.7786 3.04305 14.1454 2.39014 14.7983C1.73724 15.4513 1.37044 16.3368 1.37044 17.2601V19.3342C1.37044 19.7024 1.07197 20.0009 0.703776 20.0009C0.335586 20.0009 0.0371094 19.7024 0.0371094 19.3342V17.2601C0.0371094 15.9832 0.544383 14.7585 1.44734 13.8555Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00007 1.33333C7.0773 1.33333 5.51859 2.89205 5.51859 4.81482C5.51859 6.73758 7.0773 8.2963 9.00007 8.2963C10.9228 8.2963 12.4816 6.73758 12.4816 4.81482C12.4816 2.89205 10.9228 1.33333 9.00007 1.33333ZM4.18526 4.81482C4.18526 2.15567 6.34092 0 9.00007 0C11.6592 0 13.8149 2.15567 13.8149 4.81482C13.8149 7.47396 11.6592 9.62963 9.00007 9.62963C6.34092 9.62963 4.18526 7.47396 4.18526 4.81482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleVector);
export default __webpack_public_path__ + "static/media/peopleVector.9782c613f248fbf0a0bab86b840d9afb.svg";
export { ForwardRef as ReactComponent };